import {
  GenerateElementTokenDocument,
  GenerateElementTokenMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useGenerateElementToken = () => {
  const [generateElementToken, { loading }] = useMutation(GenerateElementTokenDocument, {
    extractorFn: (data) =>
      data.cronofySchedulingMutations.generateElementTokenCronofyschedulingCalendarSync,
  })

  return {
    loading,
    generate(variables: GenerateElementTokenMutationVariables) {
      return generateElementToken({
        variables,
      })
    },
  }
}
